import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asset-text",
  "use": "asset-text-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"asset-text\"><g fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\"><path d=\"M3 11h14c.6 0 1-.5 1-1 0-.6-.4-1-1-1H3a1 1 0 00-1 1c0 .5.5 1 1 1M3 7h18c.6 0 1-.5 1-1 0-.6-.4-1-1-1H3a1 1 0 00-1 1c0 .5.5 1 1 1M21 13H3a1 1 0 00-1 1c0 .5.5 1 1 1h18c.6 0 1-.5 1-1 0-.6-.4-1-1-1M17 17H3a1 1 0 00-1 1c0 .5.5 1 1 1h14c.6 0 1-.5 1-1 0-.6-.4-1-1-1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol